import React from 'react';
import classnames from 'classnames';
import flags from './flags@2x.png';
import styles from './intlPhoneFlagIcon.css';
var IntlPhoneFlagIcon = function (_a) {
    var iso2 = _a.iso2, classes = _a.classes;
    return (React.createElement("div", { className: classnames(styles.FlagIcon__Wrapper, styles["Flag__".concat(iso2)], classes), style: { backgroundImage: "url(".concat(flags, ")") } }));
};
export { IntlPhoneFlagIcon };
